
import {share} from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { HttpHeaders } from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class HttpService{

    get headers(): HttpHeaders{
        return new HttpHeaders({
            //'Content-Type': 'application/json; charset=UTF-8',
        });
    }

    constructor(
        private httpClient: HttpClient
    ){

    }


    /** Realiza requisições HTTP GET 
     * @param url endereço HTTP a ser requisitado
     * @param headers (opcional) Cabeçalhos HTTP a serem usados na requisição
     **/
    get<T>(url: string, headers?: HttpHeaders): Observable<T> {
        return this.httpClient.get<T>(url, { headers: headers? headers : this.headers}).pipe(share());
    }

    /** Realiza requisições HTTP GET esperando um blob como resposta
     * @param url endereço HTTP a ser requisitado
     * @param headers (opcional) Cabeçalhos HTTP a serem usados na requisição
     **/
    getFile(url: string, headers?: HttpHeaders): Observable<any> {
        return this.httpClient.get(url, { responseType: 'blob', headers: headers? headers : this.headers }).pipe(share());
    }

    /** Realiza requisições HTTP POST 
     * @param url endereço HTTP a ser requisitado
     * @param payload body da requisição,
     * @param headers (opcional) Cabeçalhos HTTP a serem usados na requisição
     **/
    post<T>(url: string, payload: any, headers?: HttpHeaders): Observable<T> {
        return this.httpClient.post<T>(url, payload, { headers: headers? headers : this.headers}).pipe(share());
    }

    /** Realiza requisições HTTP PATCH 
     * @param url endereço HTTP a ser requisitado
     * @param payload body da requisição,
     * @param headers (opcional) Cabeçalhos HTTP a serem usados na requisição
     **/
    patch<T>(url: string, payload: any, headers?: HttpHeaders): Observable<T> {
        return this.httpClient.patch<T>(url, payload, { headers: headers? headers : this.headers}).pipe(share());
    }

    /** Realiza requisições HTTP DELETE 
     * @param url endereço HTTP a ser requisitado
     * @param payload body da requisição,
     * @param headers (opcional) Cabeçalhos HTTP a serem usados na requisição
     **/
    delete<T>(url: string,headers?: HttpHeaders): Observable<T> {
        return this.httpClient.delete<T>(url, { headers: headers? headers : this.headers}).pipe(share());
    }

    /** Realiza requisições HTTP PUT
     * @param url endereço HTTP a ser requisitado
     * @param payload body da requisição,
     * @param headers (opcional) Cabeçalhos HTTP a serem usados na requisição
     **/
    put<T>(url: string, payload: any, headers?: HttpHeaders): Observable<T> {
        return this.httpClient.put<T>(url, payload, { headers: headers? headers : this.headers}).pipe(share());
    }
    
}